<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.25 11H19V3.25A1.25 1.25 0 0017.75 2H3.25A1.25 1.25 0 002 3.25v11.5A1.25 1.25 0 003.25 16H6v2a1.26 1.26 0 00.67 1.11 1.34 1.34 0 00.58.14A1.28 1.28 0 008 19l4-2.82v3.53a.76.76 0 00.75.75h3.09l2 1.38a.76.76 0 00.43.14.85.85 0 00.35-.08.75.75 0 00.4-.67v-.73h2.25a.76.76 0 00.75-.75v-8a.76.76 0 00-.77-.75zM8 16.58V14H4V4h13v10h-5.32zm13 2.92h-3v1.29l-1.84-1.29H13V16h4.75A1.25 1.25 0 0019 14.75V12h2z"/></svg>